import { defaultHttpClient } from 'shared/src/api/httpClient';

export const postLikeOutfit = (sno: number) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: `/api/v2/outfits/${sno}/likes/`,
    })
    .then(result => result.data);
};
